import { createUseStyles } from 'react-jss'
import { lightGrey, trafficRedDark } from '../../../../../../../styles/const/colors'
import { formSection, formSectionTitle } from '../../../../../../../styles/common/drawerForms'
import { transitionShort } from '../../../../../../../styles/const/common'

// When the component renders for the first time, isValid is undefined
// So we must check if isValid is true or undefined and there are no errors with a media file
// to add a proper border to carousel item form component
// (red if errors, yellow if active without errors, and grey if not active without errors)
const borderColor = (props, theme) => {
  const { isItemActive, isValid, mediaFileError } = props
  const isNoErrors = (isValid || isValid === undefined) && !mediaFileError

  if (!isItemActive && isNoErrors) {
    return lightGrey
  } else if (isItemActive && isNoErrors) {
    return theme.brandPrimary
  } else if (!isNoErrors) {
    return trafficRedDark
  }
}

const useStyles = createUseStyles(theme => ({
  carouselItemForm: {
    extend: formSection,
    marginTop: 16,
    borderColor: props => borderColor(props, theme)
  },
  title: {
    extend: formSectionTitle,
    marginBottom: 0,
    paddingRight: 32
  },
  iconButton: {
    width: 'auto',
    top: 10,
    right: 10,
    '& svg': {
      width: 20
    }
  },
  carouselItemFormMinimized: {
    cursor: 'pointer',
    transition: transitionShort,

    '&:hover': {
      boxShadow: '0 1px 5px 2px rgba(0,0,0,.05)'
    }
  },
  removePostBtn: {
    position: 'absolute',
    top: 10,
    right: 46
  },
  addAnotherButton: {
    marginTop: 20,
    width: '100%',
    padding: '15px 25px'
  }
}))

export default useStyles
